// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./RadioTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-max-specificity -- design system */
/* stylelint-disable property-disallowed-list -- design system */

.RadioInput-module__Container__yBOad {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.RadioInput-module__DefaultDisabled__boZ3z {
    gap: var(--ds-gap-m);
    padding: var(--ds-sm) var(--ds-m);
    background-color: var(--ds-radio-container-disabled-bg-color);
    border-color: var(--ds-radio-container-border-color);
    border-style: solid;
    border-width: var(--ds-border-width);
    border-radius: var(--ds-border-radius-sm);
    cursor: default;
}

.RadioInput-module__CompactDisabled__g3OD3 {
    gap: var(--ds-gap-s);
    padding: var(--ds-s);
    border: none;
    border-radius: var(--ds-border-radius-s);
    cursor: default;
}

.RadioInput-module__Default__SVYn4 {
    gap: var(--ds-gap-m);
    padding: var(--ds-sm) var(--ds-m);
    background-color: var(--ds-radio-container-bg-color);
    border-color: var(--ds-radio-container-border-color);
    border-style: solid;
    border-width: var(--ds-border-width);
    border-radius: var(--ds-border-radius-sm);
}

.RadioInput-module__Default__SVYn4:hover {
    border-color: var(--ds-radio-container-hover-border-color);
}

.RadioInput-module__ContainerChecked__bfLvP:hover {
    border-color: var(--ds-radio-container-border-color);
}

.RadioInput-module__Disabled__tXKs4:hover {
    border-color: var(--ds-radio-container-border-color);
}

.RadioInput-module__Compact__l4pb8 {
    gap: var(--ds-gap-s);
    padding: var(--ds-s);
    border: none;
    border-radius: var(--ds-border-radius-s);
}

.RadioInput-module__RadioWrapper__gGZYk {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(--ds-5x);
    max-width: var(--ds-5x);
    min-height: var(--ds-5x);
    max-height: var(--ds-5x);
    background-color: var(--ds-radio-input-bg-color);
    border-color: var(--ds-radio-border-color);
    border-style: solid;
    border-width: var(--ds-border-width-focus);
    border-radius: var(--ds-border-radius-m);
}

.RadioInput-module__Container__yBOad:hover .RadioInput-module__RadioWrapper__gGZYk {
    border-color: var(--ds-radio-hover-border-color);
}

.RadioInput-module__Container__yBOad:hover .RadioInput-module__RadioWrapperChecked__VZFHe {
    border-color: var(--ds-radio-selected-border-color);
}

.RadioInput-module__Container__yBOad:hover .RadioInput-module__RadioWrapperCheckedDisabled__pGCpF {
    border-color: var(--ds-radio-border-color);
}

.RadioInput-module__Disabled__tXKs4:hover .RadioInput-module__RadioWrapper__gGZYk {
    border-color: var(--ds-radio-border-color);
}

.RadioInput-module__RadioWrapperChecked__VZFHe {
    border-color: var(--ds-radio-selected-border-color);
}

.RadioInput-module__RadioWrapperFocused__Yl4QG {
    border-color: var(--ds-radio-selected-fill);
}

.RadioInput-module__RadioWrapperCheckedDisabled__pGCpF {
    border-color: var(--ds-radio-border-color);
}

.RadioInput-module__Radio__Jq9es {
    outline: none;
    cursor: pointer;
    appearance: none;
}

.RadioInput-module__RadioChecked___vWql {
    width: calc(var(--ds-5x) / 2);
    height: calc(var(--ds-5x) / 2);
    background-color: var(--ds-radio-selected-fill);
    border: none;
    border-radius: var(--ds-border-radius-s);
}

.RadioInput-module__RadioCheckedDisabled__YKDkV {
    background-color: var(--ds-radio-border-color);
    cursor: default;
}

.RadioInput-module__Details__M_CzL {
    display: flex;
    flex-direction: column;
    gap: var(--ds-gap-xs);
}

.RadioInput-module__Label__SCYCP {
    color: var(--ds-radio-input-color);
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height);
}

.RadioInput-module__Disabled__tXKs4 .RadioInput-module__Label__SCYCP {
    color: var(--ds-radio-input-disabled-color);
}

.RadioInput-module__Description__TozVj {
    color: var(--ds-radio-input-description-color);
    font-weight: var(--ds-font-weight-medium);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height);
}

.RadioInput-module__Disabled__tXKs4 .RadioInput-module__Description__TozVj {
    color: var(--ds-radio-input-disabled-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `RadioInput-module__Container__yBOad`,
	"DefaultDisabled": `RadioInput-module__DefaultDisabled__boZ3z`,
	"CompactDisabled": `RadioInput-module__CompactDisabled__g3OD3`,
	"Default": `RadioInput-module__Default__SVYn4`,
	"ContainerChecked": `RadioInput-module__ContainerChecked__bfLvP`,
	"Disabled": `RadioInput-module__Disabled__tXKs4`,
	"Compact": `RadioInput-module__Compact__l4pb8`,
	"RadioWrapper": `RadioInput-module__RadioWrapper__gGZYk`,
	"RadioWrapperChecked": `RadioInput-module__RadioWrapperChecked__VZFHe`,
	"RadioWrapperCheckedDisabled": `RadioInput-module__RadioWrapperCheckedDisabled__pGCpF`,
	"RadioWrapperFocused": `RadioInput-module__RadioWrapperFocused__Yl4QG`,
	"Radio": `RadioInput-module__Radio__Jq9es`,
	"RadioChecked": `RadioInput-module__RadioChecked___vWql`,
	"RadioCheckedDisabled": `RadioInput-module__RadioCheckedDisabled__YKDkV`,
	"Details": `RadioInput-module__Details__M_CzL`,
	"Label": `RadioInput-module__Label__SCYCP`,
	"Description": `RadioInput-module__Description__TozVj`
};
export default ___CSS_LOADER_EXPORT___;
